import { pnlAxisLabelStyle } from 'src/components/star-grid/utils/pnlAxisPresentation';
import { ColDef, GridApi } from 'ag-grid-community';
import { PNL_STATEMENT_LINE_DIMENSION } from 'src/components/star-grid/starGridConstants';
import { PnlGridRow, PnlPivotModel } from 'src/components/star-grid/starGridTypes';

/** Returned statement lines include subtotals. Render them flat without client aggregation. */
export const isStatementModel = (model: PnlPivotModel): boolean => model.dimensionFields.includes(PNL_STATEMENT_LINE_DIMENSION);

export const statementDimensionColumns = (model: PnlPivotModel, labels?: Readonly<Record<string, string>>): ColDef<PnlGridRow>[] =>
  model.dimensionFields.map((field) => ({
    field,
    headerName: labels?.[field] ?? field,
    pinned: 'left',
    width: 260,
    minWidth: 160,
    headerComponent: 'pnlHierarchyHeader',
    headerClass: 'sg-report-hierarchy-header',
    cellStyle: pnlAxisLabelStyle,
    sortable: false,
    valueGetter: ({ data }) => (field === PNL_STATEMENT_LINE_DIMENSION ? data?.label ?? data?.[field] : data?.[field])
  }));

export const togglePnlColumns = (api?: GridApi<PnlGridRow>): void => {
  if (!api) return;
  if (api.isToolPanelShowing()) {
    api.closeToolPanel();
    api.setSideBarVisible(false);
  } else {
    api.setSideBarVisible(true);
    api.openToolPanel('columns');
  }
};
